import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container, Typography, Grid, Button } from '@mui/material';
import { Close, Check, TrendingUp } from '@mui/icons-material';
import { servicesColors as colors } from '../theme';
export const PainPointsSection = () => {
    return (_jsx(Box, { component: "section", sx: {
            py: { xs: 8, md: 12 },
            backgroundColor: '#ffffff',
        }, children: _jsxs(Container, { maxWidth: "lg", children: [_jsxs(Box, { sx: { textAlign: 'center', mb: 8 }, children: [_jsx(Typography, { variant: "h2", sx: {
                                fontWeight: 700,
                                color: colors.text,
                                fontSize: { xs: '1.75rem', md: '2.5rem' },
                                mb: 2
                            }, children: "Skilled Techs Don't Wait Around" }), _jsx(Typography, { sx: {
                                color: colors.textSecondary,
                                fontSize: '1.1rem',
                                maxWidth: 650,
                                mx: 'auto'
                            }, children: "The best HVAC techs, electricians, and mechanics get multiple offers within days. Manual screening means losing them to faster competitors." })] }), _jsxs(Grid, { container: true, spacing: 4, alignItems: "stretch", children: [_jsx(Grid, { size: { xs: 12, md: 5 }, children: _jsxs(Box, { sx: {
                                    p: 4,
                                    height: '100%',
                                    backgroundColor: '#FEF2F2',
                                    borderRadius: 4,
                                    border: '2px solid #FECACA',
                                }, children: [_jsxs(Box, { sx: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            mb: 3
                                        }, children: [_jsx(Box, { sx: {
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: 2,
                                                    backgroundColor: '#FEE2E2',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }, children: _jsx(Close, { sx: { color: '#DC2626' } }) }), _jsx(Typography, { sx: { fontWeight: 700, color: '#991B1B', fontSize: '1.1rem' }, children: "Manual Screening" })] }), [
                                        'Read every resume line by line',
                                        'Google trade licenses manually',
                                        'Call to verify certifications',
                                        'Miss great candidates in the pile',
                                        'Lose techs to faster competitors',
                                    ].map((item, index) => (_jsxs(Box, { sx: {
                                            py: 1.5,
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: 1.5,
                                        }, children: [_jsx(Close, { sx: { fontSize: '1rem', color: '#DC2626', mt: 0.3 } }), _jsx(Typography, { sx: { color: '#7F1D1D', fontSize: '0.95rem' }, children: item })] }, index)))] }) }), _jsx(Grid, { size: { xs: 12, md: 2 }, sx: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }, children: _jsx(Box, { sx: {
                                    width: 64,
                                    height: 64,
                                    borderRadius: '50%',
                                    background: colors.gradient,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: '0 8px 24px rgba(30, 64, 175, 0.3)',
                                }, children: _jsx(TrendingUp, { sx: { color: '#ffffff', fontSize: 28 } }) }) }), _jsx(Grid, { size: { xs: 12, md: 5 }, children: _jsxs(Box, { sx: {
                                    p: 4,
                                    height: '100%',
                                    backgroundColor: '#ECFDF5',
                                    borderRadius: 4,
                                    border: '2px solid #6EE7B7',
                                }, children: [_jsxs(Box, { sx: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            mb: 3
                                        }, children: [_jsx(Box, { sx: {
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: 2,
                                                    backgroundColor: '#D1FAE5',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }, children: _jsx(Check, { sx: { color: '#059669' } }) }), _jsx(Typography, { sx: { fontWeight: 700, color: '#065F46', fontSize: '1.1rem' }, children: "With StanorAI" })] }), [
                                        'AI scans all resumes in minutes',
                                        'Auto-detects EPA, ASE, NATE, OSHA',
                                        'Extracts license info automatically',
                                        'Ranked shortlist with match scores',
                                        'Call top candidates same day',
                                    ].map((item, index) => (_jsxs(Box, { sx: {
                                            py: 1.5,
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: 1.5,
                                        }, children: [_jsx(Check, { sx: { fontSize: '1rem', color: '#059669', mt: 0.3 } }), _jsx(Typography, { sx: { color: '#065F46', fontSize: '0.95rem', fontWeight: 500 }, children: item })] }, index)))] }) })] }), _jsx(Box, { sx: { textAlign: 'center', mt: 6 }, children: _jsx(Button, { variant: "contained", color: "primary", size: "large", href: "/onboarding?industry=services", sx: { py: 1.75, px: 5 }, children: "Speed Up Your Hiring" }) })] }) }));
};
